import styled, { keyframes } from "styled-components";

import React from "react";
import discord from "../images/discord-logo.png";
import productHuntLogo from "../images/product-hunt.png";

export const Testimonials = () => {
  return (
    <FooterContainer>
      <CTAText>Join thousands of happy customers</CTAText>

      <SocialProofRow>
        <SocialProofBox
          onClick={() => window.open("https://discord.gg/8wnQndpBGU")}
        >
          <DiscordIcon src={discord} />
          <CommunityText>Join 1,850+ Frontly community members</CommunityText>
        </SocialProofBox>
        <SocialProofBox
          onClick={() =>
            window.open(
              "https://www.producthunt.com/products/frontly?utm_source=badge-featured&utm_medium=badge#frontly"
            )
          }
        >
          <ProductHuntIcon src={productHuntLogo} />
          <a
            href="https://www.producthunt.com/posts/frontly"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=459284&theme=neutral"
              alt="Frontly - Build custom apps with no code | Product Hunt"
              style={{ width: "250px", height: "54px" }}
              width="250"
              height="54"
            />
          </a>
        </SocialProofBox>
      </SocialProofRow>

      <iframe
        style={{ border: "none" }}
        src="https://cards.producthunt.com/cards/testimonials/769452,769422,769426,769491,769418,769405,769489,769446"
        width="100%"
        height="1000px"
        frameborder="0px"
        scrolling="no"
        allowfullscreen={false}
      ></iframe>
    </FooterContainer>
  );
};

const CTAText = styled.div`
  font-size: 42px;
  font-weight: 400;
  line-height: 1;
  color: black;
  text-align: center;
  width: 100%;
  margin-bottom: 50px;
  @media (max-width: 1000px) {
    font-size: 28px;
    text-align: center;
    padding-top: 10px;
  }
`;

const FooterContainer = styled.div`
  width: 100%;
  border-radius: 40px;
  margin: 0 auto;
  padding: 30px 40px 60px 40px;
  @media screen and (max-width: 900px) {
    width: calc(100% - 60px);
    padding: 20px;
  }
`;

const DiscordIcon = styled.img`
  height: 44px;
`;

const ProductHuntIcon = styled.img`
  height: 44px;
  margin-bottom: 15px;
`;

const CommunityText = styled.div`
  font-size: 22px;
  font-weight: 400;
  color: white;
  max-width: 300px;
  color: black;
  margin-top: 15px;
  text-align: center;
  @media (max-width: 1000px) {
    font-size: 20px;
  }
`;

const SocialProofBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const SocialProofRow = styled.div`
  display: flex;
  margin-bottom: 20px;
  gap: 30px;
  justify-content: center;
  width: 100%;
  margin: 60px 0px 60px 0px;
  @media (max-width: 800px) {
    flex-direction: column;
    margin: 30px 0px 30px 0px;
  }
`;
